import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MyBookingPassengerService } from '@common/services/my-booking/my-booking-passenger/my-booking-passenger.service';
import { SupportComponent } from '@lib/components/support-class';
import { DeviceType } from '@lib/interfaces';
import { CommonLibService } from '@lib/services';

@Component({
  selector: 'asw-my-booking-passenger-pres',
  templateUrl: './my-booking-passenger-pres.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyBookingPassengerPresComponent extends SupportComponent {
  constructor(private _common: CommonLibService, private _myBookingPassengerService: MyBookingPassengerService) {
    super(_common);
  }

  reload(): void {}
  init(): void {}

  /** [15.1] 旅程操作メニュー */
  get isDisplayItineraryOperationMenu(): boolean {
    return this._common.aswContextStoreService.aswContextData.deviceType === DeviceType.PC;
  }

  /** [15.2] ANA新規入会 */
  // 予約詳細(旅程)(S01-P031)の同項目を参照する。

  /** [15.3] レコメンド */
  get isDisplayRecommend() {
    return this._common.aswContextStoreService.aswContextData.deviceType === DeviceType.PC;
  }

  /** [15.4] Biz操作メニュー */
  get isBizMenu() {
    /** 操作端末がPCの場合のみを表示する。予約詳細(旅程)(S01-P031)の同項目を参照する。*/
    return this._common.aswContextStoreService.aswContextData.deviceType === DeviceType.PC;
  }

  destroy(): void {}
}
